import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Link } from "react-router-dom"
import { Search, Heart, Shield } from "lucide-react"

// Minimal three-point value proposition
export const MinimalValueProps = () => {
  const values = [
    {
      icon: Heart,
      title: "Fair",
      description: "Transparente Preise ohne versteckte Kosten"
    },
    {
      icon: Shield,
      title: "Sicher", 
      description: "Geprüfte Unterkünfte und Gastgeber"
    },
    {
      icon: Search,
      title: "Einfach",
      description: "Buchen in wenigen Klicks"
    }
  ]

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-6">
        
        {/* Minimal Grid - Maximum Whitespace */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 max-w-4xl mx-auto">
          {values.map((value, index) => (
            <div key={index} className="text-center space-y-6">
              <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                <value.icon className="h-8 w-8 text-primary" />
              </div>
              <div className="space-y-3">
                <h3 className="text-2xl font-semibold">{value.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{value.description}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

// Simplified two-path decision
export const MinimalPathChoice = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6 max-w-3xl">
        
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold">
            Was möchten Sie?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          
          {/* Guest Path */}
          <Card className="p-8 text-center hover:shadow-md transition-all border hover:border-primary/30">
            <CardContent className="space-y-6 pt-4">
              <div className="w-16 h-16 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
                <Search className="h-8 w-8 text-primary" />
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-semibold">Unterkunft buchen</h3>
                <p className="text-muted-foreground text-sm">Finden Sie Ihre perfekte Unterkunft</p>
              </div>
              <Link to="/listings">
                <Button size="lg" className="w-full">
                  Unterkünfte ansehen
                </Button>
              </Link>
            </CardContent>
          </Card>

          {/* Host Path */}
          <Card className="p-8 text-center hover:shadow-md transition-all border hover:border-primary/30">
            <CardContent className="space-y-6 pt-4">
              <div className="w-16 h-16 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
                <Heart className="h-8 w-8 text-primary" />
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-semibold">Unterkunft vermieten</h3>
                <p className="text-muted-foreground text-sm">Werden Sie Gastgeber bei Fair-Stays</p>
              </div>
              <Link to="/auth?mode=signup">
                <Button size="lg" variant="outline" className="w-full">
                  Jetzt registrieren
                </Button>
              </Link>
            </CardContent>
          </Card>

        </div>
      </div>
    </section>
  )
}

// Single focused CTA section
export const MinimalCTA = () => {
  return (
    <section className="py-24">
      <div className="container mx-auto px-6 text-center max-w-2xl">
        <h2 className="text-3xl md:text-4xl font-bold mb-8">
          Bereit loszulegen?
        </h2>
        <Link to="/auth?mode=signup">
          <Button size="lg" variant="hero" className="text-xl px-12 py-6 rounded-full">
            Kostenlos registrieren
          </Button>
        </Link>
      </div>
    </section>
  )
}